const addingAnswersAllowed = (game_type) =>
    game_type === 'first_scorer' || game_type === 'favorite_player' ? false : true;

const deletingAnswersAllowed = (game_type) =>
    game_type === 'first_scorer' || game_type === 'favorite_player' ? false : true;

const answersConfig = { addingAnswersAllowed, deletingAnswersAllowed };

export default answersConfig;
